export const TAL_AUTO_SUGGESTED = 'talAutoSuggested';